import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {AccountService} from '../../services/account.service';
import {DataTableResponse} from '../../models/DatatableResponse';
import {FacilityCategory} from '../../models/CommonModels';
import {ChangeType} from '../../models/ApplicationDetail';
import {FacilityView, UserOrganization, OrphanInspectionFacility, Facility, ChangeFakeTinModel} from '../../models/ApplicationModel';
import { Organization } from '../../models/ApplicationModel';

@Injectable({
  providedIn: 'root'
})

export class FacilityService {

  private headers: HttpHeaders;
  private facilityListURL = environment.baseUrl + '/Facility/List';
  private facilityURL = environment.baseUrl + '/Facility';
  private changeTypeURL = environment.baseUrl + '/ChangeType';
  private orphanInspectionFacilityURL = environment.baseUrl + '/OrphanInspectionFacility';
  private facilityFilterURL = environment.baseUrl + '/Facility/filter/';
  private facilityCategoryURL = environment.baseUrl + '/FacilityCategory';
  private changeFacilityEmailURL = environment.baseUrl + '/Facility/ChangeEmail';
  private changeInspectionFacilityEmailURL = environment.baseUrl + '/Facility/ChangeInspectionEmail';
  private categoryChangeHistoryURL = this.facilityURL + '/CategoryHistory';
  private extendFacilityExpiryURL = this.facilityURL + '/ExtendExpirationDate';
  private claimTinURL = this.facilityURL + '/claimTin';
  private userOrganizationURL = environment.baseUrl + '/UserOrganization'
  private applicantOrganizationAssociationsURL = this.userOrganizationURL + '/GetAssociations';
  private _facilityTypeId : number =  null;
  private _productTypeId : number = null;
  private _facilityCategoryId : number = null;

  constructor(private http: HttpClient, private accountService: AccountService) {
    this.headers = new HttpHeaders();
    this.headers = this.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    this.headers = this.headers.set('Authorization', 'Bearer '+ this.accountService.getTokenData());
  }

  getDataTableOptions(facilities) {
    const that = this;
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/x-www-form-urlencoded');
    headers = headers.set('Authorization', 'Bearer '+ this.accountService.getTokenData());

    let cols = [{ data: 'name'}, {data: 'facilityTypeName'}, {data: 'productTypeName'}, {data: 'applicantName'},  { data: 'modifiedDate' }, 
      {data: 'licenseDate'}]
    let options = {
      pagingType: 'full_numbers',
      pageLength: 10,
      serverSide: true,
      processing: true,
      order : [[4, 'desc']],
      language : {
        processing : '<div class="sk-spinner sk-spinner-three-bounce"> <div class="sk-bounce1"></div> <div class="sk-bounce2"></div> ' +
          '<div class="sk-bounce3"></div> </div>'
      },
      ajax: (dataTablesParameters: any, callback) => {
        that.http.post<DataTableResponse>(this.facilityListURL,$.param(dataTablesParameters), {headers: headers})
          .subscribe(
            resp => {
              facilities.splice(0, facilities.length)
              // can't use users=resp.data because we want to pass by reference
              for(let facility of resp.data){
                facilities.push(facility)
              }


              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: []
              });

            },
            error => {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
            }
          );
      },
      columns: cols
    }

    return options;
  }

  getFacilitiesForRenewal() {
    return this.http.get<FacilityView[]>(this.facilityURL + '/Renewable', {headers: this.headers});
  }

  getFacilitiesForChange(tempCOC) {
    if(tempCOC){
      return this.http.get<FacilityView[]>(this.facilityURL + '/TempCOCChange', {headers: this.headers});
    }else {
      return this.http.get<FacilityView[]>(this.facilityURL + '/Changeable', {headers: this.headers});
    }
  }

  getFacilitiesForCOCReturn(tempCOC){
    if(tempCOC){
      return this.http.get<FacilityView[]>(this.facilityURL + '/TempReturnCOC', {headers: this.headers});
    } else {
      return this.http.get<FacilityView[]>(this.facilityURL + '/ReturnCOC', {headers: this.headers});
    }
  }

  getFacilitiesForReplacement(){
    return this.http.get<FacilityView[]>(this.facilityURL + '/Replaceable', {headers: this.headers});
  }

  getFacilitiesForWarehouseAddition(tempCOC : boolean){
    if(tempCOC){
      return this.http.get<FacilityView[]>(this.facilityURL + '/TempCOCWarehouseAddition', {headers: this.headers});
    }
    return this.http.get<FacilityView[]>(this.facilityURL + '/WarehouseAddition', {headers: this.headers});
  }

  getFacilityChangeTypes() {
    return this.http.get<ChangeType[]>(this.changeTypeURL, {headers: this.headers});
  }

  getFacilityChangeTypesForFacilityAndProductType(facilityTypeId, productTypeId, tempCOC) {
    return this.http.get<ChangeType[]>(this.changeTypeURL + '/ByFacilityAndProductType/' + facilityTypeId + '/' + productTypeId + '/' + (tempCOC ? true : false),
      {headers: this.headers});
  }

  getAllFacilityCategories() {
    return this.http.get<FacilityCategory[]>(this.facilityCategoryURL, {headers: this.headers});
  }

  categorizeFacilities(facilityCatList) {
    this.headers = this.headers.set('Content-Type', 'application/json');
    return this.http.post<any>(this.facilityURL + '/Categorize', facilityCatList, {headers: this.headers});
  }

  getFacilityCategoryHistory(facilityId){
    return this.http.get<any>(this.categoryChangeHistoryURL + '/' + facilityId, {headers: this.headers});
  }

  getOrphanInspectionFacilityList() {
    return this.http.get<OrphanInspectionFacility[]>(this.orphanInspectionFacilityURL, {headers: this.headers});
  }

  changeFacilityEmail(facilityModel) {
    this.headers = this.headers.set('Content-Type', 'application/json');
    return this.http.post<any>(this.changeFacilityEmailURL, facilityModel, {headers: this.headers});
  }

  changeInspectionFacilityEmail(facilityModel) {
    this.headers = this.headers.set('Content-Type', 'application/json');
    return this.http.post<any>(this.changeInspectionFacilityEmailURL, facilityModel, {headers: this.headers});
  }

  extendFacilityExpiryDate(data){
    this.headers = this.headers.set('Content-Type', 'application/json');
    return this.http.post<any>(this.extendFacilityExpiryURL, data, {headers: this.headers})
  }

  claimTin(data){
    this.headers = this.headers.set('Content-Type', 'application/json');
    return this.http.post<any>(this.claimTinURL, data, {headers : this.headers});
  }

  getTinData(tinObj){
    this.headers = this.headers.set('Content-Type', 'application/json');
    return this.http.post<Organization>(this.facilityURL + '/GetTinData', tinObj, {headers : this.headers});
  }

  getOrganizationApplicantAssociations(){
    return this.http.get<UserOrganization[]>(this.applicantOrganizationAssociationsURL, {headers: this.headers});
  }

  deleteUserOrganization(id){
    return this.http.delete<any>(this.userOrganizationURL + '/' + id, {headers : this.headers});
  }

  createUserOrganization(data){
    this.headers = this.headers.set('Content-Type', 'application/json');
    return this.http.post<any>(this.userOrganizationURL, data, {headers : this.headers});
  }

  searchTinAssociationByTin(tin){
    return this.http.get<UserOrganization[]>(this.userOrganizationURL + '/GetAssociationsByTin/' + tin, {headers: this.headers});
  }

  searchTinAssociationByUser(username){
    return this.http.get<UserOrganization[]>(this.userOrganizationURL + '/GetAssociationsByUser/' + username, {headers: this.headers});
  }

  getFacilitiesByTin(tin){
    return this.http.get<Facility[]>(this.facilityURL + '/ByTin/' + tin);
  }

  changeFakeTin(changeFakeTinModel: ChangeFakeTinModel) {
    return this.http.put<boolean>(this.facilityURL + '/ChangeFakeTin', changeFakeTinModel);
  }

  getFacilityListOptions(facilities) {
    const that = this;
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/x-www-form-urlencoded');
    headers = headers.set('Authorization', 'Bearer '+ this.accountService.getTokenData());

    let cols = [{ data: 'name'}, {data: 'facilityTypeName'}, {data: 'productTypeName'}, {data: 'facilityCategory'}]
    let options = {
      pagingType: 'full_numbers',
      pageLength: 10,
      serverSide: true,
      processing: true,
      order : [[0, 'asc']],
      language : {
        processing : '<div class="sk-spinner sk-spinner-three-bounce"> <div class="sk-bounce1"></div> <div class="sk-bounce2"></div> ' +
          '<div class="sk-bounce3"></div> </div>'
      },
      ajax: (dataTablesParameters: any, callback) => {
        let url = `${this.facilityURL}/filter/${this._facilityTypeId}/${this._productTypeId}/${this._facilityCategoryId}`;
        that.http.post<DataTableResponse>(url,$.param(dataTablesParameters), {headers: headers})
          .subscribe(
            resp => {
              facilities.splice(0, facilities.length)
              // can't use users=resp.data because we want to pass by reference
              for(let facility of resp.data){
                facilities.push(facility)
              }


              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: []
              });

            },
            error => {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
            }
          );
      },
      columns: cols
    }

    return options;
  }

  set facilityTypeId(fti : number) {
    this._facilityTypeId = fti;
  }

  set productTypeId(pti: number){
    this._productTypeId = pti;
  }
  
  set facilityCategoryId(fci: number){
    this._facilityCategoryId = fci;
  }
}
